import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { pickLocalized } from "@/i18n/translations";
import api from "@/lib/api";

export default function BellArticle() {
  const { locale, t } = useI18n();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    api.get("/articles").then((r) => {
      // pick the most recent one — should be the "baptême" article
      setArticle(r.data[0] || null);
    });
  }, []);

  if (!article) {
    return (
      <div className="container-prieure py-32 text-center font-body" style={{ color: "var(--muted)" }}>
        {t.common.loading}
      </div>
    );
  }

  return (
    <div data-testid="article-page">
      <section className="relative" style={{ height: "60vh", minHeight: 440 }}>
        <img src={article.image_url} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-vignette" />
        <div className="container-prieure relative h-full flex flex-col justify-end pb-12">
          <Link to="/" className="font-caps text-[0.7rem] text-white/80 mb-4">← {t.common.back}</Link>
          <div className="font-caps text-[0.72rem]" style={{ color: "#D4AF37" }}>
            {article.author} · {new Date(article.date).toLocaleDateString(locale === "fr" ? "fr-FR" : "en-GB", {
              day: "numeric", month: "long", year: "numeric"
            })}
          </div>
          <h1 className="font-display text-5xl sm:text-7xl text-white mt-2 leading-tight">
            {pickLocalized(article.title, locale)}
          </h1>
        </div>
      </section>

      <section className="py-20">
        <div className="container-prieure max-w-3xl">
          <div className="font-body text-xl leading-relaxed drop-cap whitespace-pre-line"
               style={{ color: "var(--ink-2)" }}>
            {pickLocalized(article.body, locale)}
          </div>
        </div>
      </section>
    </div>
  );
}
